define(function(require, exports, module) {
    'use strict';

    const BaseView = require('common/base.view');

    module.exports = BaseView.extend({
        bigCount: '99+',

        countClassName: function(count) {
            let className;
            const checkCountLength = Number(count) && String(count).length;

            switch (checkCountLength) {
                case 1:
                    className = 'one-digit-counter';
                    break;
                case 2:
                    className = 'two-digit-counter';
                    break;
                case 3:
                    className = 'three-digit-counter';
                    break;
                default:
                    className = null;
            }

            return className;
        }
    });
});
